/*乙方 */
import { $http, buildHeaders } from "./index";

//获取列表
export const billunit_page = (params) => {
  return $http.get("/admin/BillUnit/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const billunit_detail = (id) => {
  return $http.get("/admin/BillUnit/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const billunit_add = (data) => {
  return $http.post("/admin/BillUnit/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const billunit_edit = (data) => {
  return $http.post("/admin/BillUnit/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};


//修改状态
export const billunit_updateStatus = (data) => {
  return $http.post("/admin/BillUnit/updateStatus", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const billunit_delete = (id) => {
  return $http.post(
    "/admin/BillUnit/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#region 联系人

//获取列表
export const billunit_contact_page = (params) => {
  return $http.get("/admin/BillUnitContact/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const billunit_contact_detail = (id) => {
  return $http.get("/admin/BillUnitContact/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const billunit_contact_add = (data) => {
  return $http.post("/admin/BillUnitContact/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const billunit_contact_edit = (data) => {
  return $http.post("/admin/BillUnitContact/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//充值/扣款
export const billunit_balanceChange = (data) => {
  return $http.post("/admin/BillUnit/balanceChange", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const billunit_contact_delete = (id) => {
  return $http.post(
    "/admin/BillUnitContact/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion


//#region 流水

//获取列表
export const billunit_balancelog_page = (params) => {
  return $http.get("/admin/BillUnitBalanceLog/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const billunit_balancelog_detail = (id) => {
  return $http.get("/admin/BillUnitBalanceLog/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//#endregion

